export default {
  data() {
    return {
      dragAndDropCapable: true,
    };
  },
  mounted() {
    // https://gist.github.com/daliborgogic/f2709d6923f1103b0e0dcaeac87c6fee
    const { dropbox } = this.$refs;
    // Determine if drag and drop functionality is capable in the browser
    this.dragAndDropCapable = this.isDragAndDropCapable();
    if (this.dragAndDropCapable) {
      ['drag', 'dragstart', 'dragend', 'dragover', 'dragenter', 'dragleave', 'drop'].forEach(
        event => {
          document.body.addEventListener(event, e => {
            e.preventDefault();
            e.stopPropagation();
          });
        }
      );
      dropbox.addEventListener('drop', e => {
        this.onFileChange(e);
      });
    }
  },
  methods: {
    isDragAndDropCapable() {
      const { dropbox } = this.$refs;
      return (
        ('draggable' in dropbox || ('ondragstart' in dropbox && 'ondrop' in dropbox)) &&
        'FormData' in window &&
        'FileReader' in window
      );
    },
  },
};
